module.exports = __webpack_public_path__ + "media/images/front/icon_db-a8efc25813c5eab6b912ecf15f2b9f85.png";